import { render, staticRenderFns } from "./stickerWrapper.vue?vue&type=template&id=bdc4c680&"
import script from "./stickerWrapper.vue?vue&type=script&lang=js&"
export * from "./stickerWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports